import * as _ from "lodash";
import * as moment from "moment";
import * as toastr from "toastr";
import * as Common from "../../Common/modules";
import * as Models from "../../Models";
import * as Routes from "../../Routes";
import * as Services from "../../Services";
import * as Shared from "../../Shared";
import { getBaseUrl } from "../../Shared/React/store/baseUrlService";

export interface IResidentialPaymentCaptureScope extends ng.IScope {
  residentialPaymentCaptureCtrl: ResidentialPaymentCaptureCtrl;
}

export class ResidentialPaymentCaptureCtrl {
  public paymentType = "ELECTRONIC_CHECK";
  public residentialCustomerCaptureProfile: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomer;
  public residentialCustomerInformationRequest: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomerInformationRequest;
  public formControlVariables =
    new Models.PaymentCapture.PaymentCaptureFormControlVariables.PaymentCaptureFormControlVariables();
  public possibleEscalators: Models.CostCalculation.Escalator.IEscalator[];
  public roleList = new Models.Auth.RoleList.RoleList();
  public userCanBypassPayment = false;
  public expirationMonth: number;
  public expirationYear: number;
  public years: number[];
  public accountNumberVerify: number;
  public months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  public cardTypes = ["American Express", "Discover", "MasterCard", "Visa"];
  public completionTime: Date;
  public igsCustomerNumber: string;
  public doesOpportunityNumberExist: boolean;
  public callBlackoutActive: boolean;
  public partnersSettings: Models.PartnerSettingsModel.PartnerSettings;

  public static $inject = [
    "$scope",
    "$state",
    "PaymentCaptureApiClient",
    "$timeout",
    "$http",
    "PartnerRetrievalService",
    "UserService",
    "$rootScope",
    "CallRecordingApiClient",
    "DocusignApiClient",
    "CustomerApiClient",
  ];
  constructor(
    public $scope: IResidentialPaymentCaptureScope,
    private $state: angular.ui.IStateService,
    private paymentCaptureApiClient: Services.PaymentCaptureApiClient.IPaymentCaptureApiClient,
    private $timeout: ng.ITimeoutService,
    private $http: ng.IHttpService,
    private partnerRetrievalService: Services.PartnerRetrievalService.IPartnerRetrievalService,
    private userService: Services.UserService.IUserService,
    private $rootScope: ng.IRootScopeService,
    private callRecordingApiClient: Services.CallRecordingApiClient.ICallRecordingApiClient,
    private docusignApiClient: Services.DocusignApiClient.IDocusignApiClient,
    private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
  ) {
    $scope.residentialPaymentCaptureCtrl = this;

    this.userService.isUserInRole(this.roleList.bypassPayment).then((response) => {
      this.userCanBypassPayment = response;
    });

    $rootScope.$on("$stateChangeStart", ((
      event: angular.IAngularEvent,
      toState: angular.ui.IState,
      toParams: any,
      fromState: angular.ui.IState,
      fromParams: any,
    ) => {
      if (fromState.name === "main.residentialPaymentCapture") {
        if (this.callBlackoutActive) {
          this.blackoutCallStop();
        }
      }
    }) as any);

    this.isGenesysAuthenticated();

    this.setWatchOnPaymentTypeChanges($scope);
    this.buildYears();
    this.callBlackoutActive = false;

    this.igsCustomerNumber = $state.params["igsCustomerNumber"];
    this.residentialCustomerInformationRequest =
      new Models.PaymentCapture.PaymentCaptureCustomer.ResidentialPaymentCaptureCustomerInformationRequest(
        this.igsCustomerNumber,
      );

    this.populateFieldsWithCustomerData();
  }

  public isGenesysAuthenticated = (): void => {
    this.callRecordingApiClient.isAuthenticated().then((result: boolean) => {
      if (!result) {
        this.authenticate();
      }
    });
  };
  private authenticate = (): void => {
    var base = Shared.Constants.Reference.Reference.Genesys_BaseUrl;
    var redirect_uri = `${getBaseUrl()}genesysAuthRedir`;
    var org = Shared.Constants.Reference.Reference.Genesys_Org;
    var provider = Shared.Constants.Reference.Reference.Genesys_Provider;
    var clientId = Shared.Constants.Reference.Reference.Genesys_ClientId;
    var target = Shared.Constants.Reference.Reference.Genesys_Target;
    var state = btoa(window.location.href);
    var genesysAuthUrl = `${base}?client_id=${clientId}&response_type=code&redirect_uri=${redirect_uri}&org=${org}&provider=${provider}&target=${target}&state=${state}`;
  };

  public populateFieldsWithCustomerData = (): void => {
    this.paymentCaptureApiClient
      .getResidentialPaymentCaptureCustomerInformation(this.residentialCustomerInformationRequest)
      .then(
        (result: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomer) => {
          this.residentialCustomerCaptureProfile = result;
          result.igsCustomerNumber = this.igsCustomerNumber;
          this.residentialCustomerCaptureProfile.paymentInfo = new Models.PaymentCapture.PaymentInfo.PaymentProfile();

          this.resolveResidentialProfilePayload();

          this.getPartnerDetails();

          if (!!this.residentialCustomerCaptureProfile.customer.partnerCustomerNumber) {
            this.formControlVariables.customerHasPartnerCustomerNumber = true;
          }
        },
        () => {
          this.$state.go("main.customersearchv2");
          toastr.error("Please try searching for customer", "Customer Not Found");
        },
      );
  };

  public resolveResidentialProfilePayload = (): void => {
    //Hack to force cast phone number to number
    this.residentialCustomerCaptureProfile.customer.phoneNumber =
      +this.residentialCustomerCaptureProfile.customer.phoneNumber.toString();
    this.possibleEscalators = [];
    this.possibleEscalators.push(this.residentialCustomerCaptureProfile.escalator);
    this.formControlVariables.escalatorBackgroundColor = "#f2f2f2";
  };

  public blackoutCallStart = (): void => {
    var request = new Models.CallRecording.CallRecordingRequest.CallRecordingRequest();
    request.verifyRecording = false;

    this.callRecordingApiClient.blackoutCallStart(request).then(
      () => {
        this.callBlackoutActive = true;
      },
      () => {
        this.callBlackoutActive = false;
        toastr.error("An error has occurred!", "Unable to black out call recording");
      },
    );
  };

  public blackoutCallStop = (): void => {
    var request = new Models.CallRecording.CallRecordingRequest.CallRecordingRequest();
    request.verifyRecording = false;

    if (this.residentialCustomerCaptureProfile.shouldDisplaySilenceCallRecording) {
      this.callRecordingApiClient.blackoutCallStop(request).then(() => {
        this.callBlackoutActive = false;
      });
    }
  };

  public submitResidentialPaymentCapture = (): void => {
    this.formControlVariables.submittingPaymentCapture = true;

    if (this.residentialCustomerCaptureProfile.paymentInfo.creditCard) {
      this.formatCreditCardForSubmission();
    }

    this.doesOpportunityAlreadyExist();
  };

  private doesOpportunityAlreadyExist = (): void => {
    this.paymentCaptureApiClient
      .doesOpportunityAlreadyExist(this.residentialCustomerCaptureProfile)
      .then((result: boolean) => {
        this.doesOpportunityNumberExist = result;
        if (!this.doesOpportunityNumberExist) {
          this.paymentCaptureApiClient.submitResidentialPaymentCapture(this.residentialCustomerCaptureProfile).then(
            (data: Models.PaymentCapture.PaymentCaptureResponse.PaymentCaptureResponse) => {
              this.handlePaymentResponse(data);
            },
            () => {
              this.formControlVariables.submittingPaymentCapture = false;
            },
          );
        } else {
          toastr.error("Opportunity numbers may not be used more than once", "Opportunity Number Already Exists");
          this.formControlVariables.submittingPaymentCapture = false;
        }
      });
  };

  public goToPaymentAuthForm = (): void => {
    this.docusignApiClient.getPaymentAuthEnvelopeUrlForCustomer(this.igsCustomerNumber).then(
      (envelopeUrl: string) => {
        document.location.href = envelopeUrl;
      },
      () => {
        toastr.error("Error loading docusign credit authorization signing session.");
      },
    );
  };

  public formatCreditCardForSubmission = (): void => {
    this.residentialCustomerCaptureProfile.paymentInfo.creditCard.expiration = new Date(
      this.expirationYear,
      this.expirationMonth - 1,
      1,
    );
    if (this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "Visa") {
      this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType = 1;
    }
    if (this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "MasterCard") {
      this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType = 2;
    }
    if (this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "Discover") {
      this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType = 3;
    }
    if (this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "American Express") {
      this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType = 4;
    }
  };

  public startNewPaymentCapture = (): void => {
    this.residentialCustomerCaptureProfile.paymentInfo = new Models.PaymentCapture.PaymentInfo.PaymentProfile();
    this.residentialCustomerCaptureProfile.customer = new Models.Customer.Customer.Customer();
    this.residentialCustomerCaptureProfile.billingAddress = new Models.Customer.Address.Address();
    this.residentialCustomerCaptureProfile.serviceAddress = new Models.Customer.Address.Address();
    this.residentialCustomerCaptureProfile.escalator = this.possibleEscalators[0];

    this.residentialCustomerCaptureProfile.paymentInfo.creditCard = null;
    this.residentialCustomerCaptureProfile.paymentInfo.ach = null;
    this.residentialCustomerCaptureProfile.paymentInfo.bypassPayment = false;
    this.expirationMonth = null;
    this.expirationYear = null;
    this.accountNumberVerify = null;
    this.paymentType = "ELECTRONIC_CHECK";
    this.formControlVariables =
      new Models.PaymentCapture.PaymentCaptureFormControlVariables.PaymentCaptureFormControlVariables();

    this.populateFieldsWithCustomerData();
  };

  public returnToHomePage = (): void => {
    this.$state.go("main.customersearchv2");
  };

  public resubmitPaymentCapture = (): void => {
    this.formControlVariables =
      new Models.PaymentCapture.PaymentCaptureFormControlVariables.PaymentCaptureFormControlVariables();
    this.formControlVariables.editPaymentCaptureOnly = true;
  };

  private handlePaymentResponse = (
    paymentCaptureResponse: Models.PaymentCapture.PaymentCaptureResponse.IPaymentCaptureResponse,
  ): void => {
    if (paymentCaptureResponse.responseCode === -1) {
      this.formControlVariables.paymentResult = paymentCaptureResponse.responseMessage;
      this.formControlVariables.responseCode = paymentCaptureResponse.responseCode;
      this.formControlVariables.hasSubmittedPaymentCapture = true;
      this.formControlVariables.submittingPaymentCapture = false;
      this.formControlVariables.hasError = true;
      this.completionTime = new Date();
    } else if (paymentCaptureResponse.responseCode === -2) {
      this.formControlVariables.submittingPaymentCapture = false;
      toastr.error("An opportunity number can not exist twice!", "Opportunity number already exits");
    } else {
      this.blackoutCallStop();

      if (this.residentialCustomerCaptureProfile.paymentInfo.bypassPayment) {
        this.$state.go("main.residentialPaymentCaptureConfirmation", {
          customerNumber: this.residentialCustomerCaptureProfile.igsCustomerNumber,
        });
      } else {
        this.goToPaymentAuthForm();
      }
    }
  };

  public toggleBillingAddressSameAsService = (): void => {
    if (this.formControlVariables.billingSameAsService) {
      this.residentialCustomerCaptureProfile.serviceAddress = this.residentialCustomerCaptureProfile.billingAddress;
    } else {
      this.residentialCustomerCaptureProfile.serviceAddress = new Models.Customer.Address.Address();
    }
  };

  public returnToCustomerProfile = (): void => {
    if (this.callBlackoutActive) {
      this.blackoutCallStop();
    }
    this.$state.go("main.customerv2", {
      igsCustomerNumber: this.igsCustomerNumber,
    });
  };

  private buildYears = (): void => {
    this.years = [];
    for (var i = 0; i <= 10; i++) {
      this.years.push(moment().add(i, "years").year());
    }
  };

  private setWatchOnPaymentTypeChanges = ($scope: ng.IScope): void => {
    $scope.$watch("residentialPaymentCaptureCtrl.paymentType", () => {
      if (!this.residentialCustomerCaptureProfile) {
        this.residentialCustomerCaptureProfile =
          new Models.PaymentCapture.PaymentCaptureCustomer.ResidentialPaymentCaptureCustomer();
      }

      if (!this.residentialCustomerCaptureProfile.paymentInfo) {
        this.residentialCustomerCaptureProfile.paymentInfo = new Models.PaymentCapture.PaymentInfo.PaymentProfile();
      }

      this.residentialCustomerCaptureProfile.paymentInfo.creditCard = null;
      this.residentialCustomerCaptureProfile.paymentInfo.ach = null;
      this.residentialCustomerCaptureProfile.paymentInfo.bypassPayment = false;
      this.expirationMonth = null;
      this.expirationYear = null;
      this.accountNumberVerify = null;

      if (this.paymentType === "BYPASS_PAYMENT") {
        this.residentialCustomerCaptureProfile.paymentInfo.bypassPayment = true;
      }
    });
  };

  private securityCodeValid = (): boolean => {
    if (
      this.residentialCustomerCaptureProfile &&
      this.residentialCustomerCaptureProfile.paymentInfo &&
      this.residentialCustomerCaptureProfile.paymentInfo.creditCard
    ) {
      var code = this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardVerificationValue;

      return (
        ((this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "Visa" ||
          this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "Discover" ||
          this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "MasterCard") &&
          String(code).trim().length === 3) ||
        (this.residentialCustomerCaptureProfile.paymentInfo.creditCard.cardType === "American Express" &&
          String(code).trim().length === 4)
      );
    }
    return false;
  };

  private expirationDateValid = (): boolean => {
    var year = this.expirationYear;
    var month = this.expirationMonth;

    return !Number(year) || !this.inPast(year, month);
  };

  private inPast = (year: number, month: number): boolean => {
    if (Number(month)) {
      var today = Number("" + moment().year() + moment().format("MM")),
        exDate = Number("" + year + month);
      return exDate < today;
    } else if (Number(year)) {
      return moment().year() > year;
    } else {
      return null;
    }
  };

  private validRate = (): boolean => {
    if (this.residentialCustomerCaptureProfile && this.residentialCustomerCaptureProfile.rate) {
      return this.residentialCustomerCaptureProfile.rate > 0 && this.residentialCustomerCaptureProfile.rate <= 0.25;
    }
    return false;
  };

  private validMonthlyPayment = (): boolean => {
    if (this.residentialCustomerCaptureProfile && this.residentialCustomerCaptureProfile.monthlyPayment) {
      return (
        this.residentialCustomerCaptureProfile.monthlyPayment > 0 &&
        this.residentialCustomerCaptureProfile.monthlyPayment <= 1000
      );
    }
    return false;
  };

  private getPartnerDetails = (): void => {
    if (this.residentialCustomerCaptureProfile.customer.partnerCode != null) {
      this.partnerRetrievalService
        .getPartnerSettings(this.residentialCustomerCaptureProfile.customer.partnerCode)
        .then((partnersSettings: Models.PartnerSettingsModel.PartnerSettings) => {
          this.partnersSettings = partnersSettings;
        });
    }
  };
}
